import { useContext } from 'react';
import { BaseScreenAttributes, ScreenBackgroundType } from 'core/flow/entities';
import { QuizContext } from 'core/funnel/contexts';

export function useFlowLayout(screenId: string): { background?: ScreenBackgroundType } {
  const { getScreenAttributes } = useContext(QuizContext);

  const { content } = getScreenAttributes(screenId) as BaseScreenAttributes;

  return { background: content?.background };
}
